// @flow
import moment from 'moment'
import React from 'react'
import { connect } from 'react-redux'
import ReactTable from 'react-table'
import {
  getSelectedCustomerId,
  selectCustomer,
} from '../../stores/ui/selectedCustomer'
import { selectCurrentUser } from '../../stores/currentUser'
import { getAnalytics, clearAnalyticsPolls } from '../../stores/analytics'
import { fetchAnalyticsImpressions } from '../../sagas/analytics/fetchImpressions'

import CustomerSelect from '../CustomerSelect'
import IfAdmin from '../IfAdmin'
import { goToPollWhereId } from '../../stores/routing'

import type Moment from 'moment'

import 'react-table/react-table.css'
import './index.css'
import { exportCSVFile, downloadFile } from '../../util'
import ColorButton from '../Controls/ColorButton'
import OpinaryDatePicker from '../DatePicker'

type Props = {
  selectedCustomerId: string,
  analytics: {
    polls: Object[],

    timeframe: string,
    timeframe: 'previous_day',
    impressions: number,
    impressionsAutomated: number,
    impressionsManual: number,
    votes: number,
    votesAutomated: number,
    votesManual: number,
    engagementRate: number,
    engagementRateAutomated: number,
    engagementRateManual: number,
  },
  user: {
    customerId: string,
  },

  selectCustomer: Function,
  clearAnalyticsPolls: Function,
  fetchAnalyticsImpressions: Function,
  goToPollWhereId: Function,
}

type State = {
  startDate: Moment,
  endDate: Moment,
}

export class Analytics extends React.Component<Props, State> {
  state = {
    startDate: moment().subtract(7, 'd'),
    endDate: moment().subtract(1, 'd'),
  }

  handleChangeStart = (date: Moment) => this.setState({ startDate: date })

  handleChangeEnd = (date: Moment) => this.setState({ endDate: date })

  handlerSearch = () => this.fetchReport()

  handlerDowload = (report: Object) => {
    if (report) {
      const blob = exportCSVFile(Object.keys(report.polls[0]), [
        ...report.polls,
      ])
      const fileName = `Opinary-report-${Date.now()}.csv`
      downloadFile(blob, fileName)
    }
  }

  handleSelectCustomer = (customerId: string) => {
    const { selectCustomer } = this.props

    selectCustomer(customerId)
    this.fetchReport(customerId)
  }

  fetchReport = (customerId?: string) => {
    const {
      clearAnalyticsPolls,
      user,
      selectedCustomerId,
      fetchAnalyticsImpressions,
    } = this.props
    clearAnalyticsPolls()
    const { startDate, endDate } = this.state
    fetchAnalyticsImpressions(
      customerId || selectedCustomerId || user.customerId,
      {
        startDate: startDate.format('YYYY-MM-DD'),
        endDate: endDate.format('YYYY-MM-DD'),
      }
    )
  }

  componentWillMount() {
    this.fetchReport()
  }

  renderChevrons() {
    return (
      <span className="flex flex-column justify-center">
        <span className="display-sorting-asc chevron-arrow-up" />
        <span className="display-sorting-desc chevron-arrow-down" />
      </span>
    )
  }

  render() {
    const { analytics, selectedCustomerId } = this.props
    const { startDate, endDate } = this.state
    const columns = [
      {
        Header: () => (
          <span className="flex">
            <span className="mr2">Headline</span>
            {this.renderChevrons()}
          </span>
        ),
        Cell: row => (
          <span
            className="pointer hover-op-con-dark underline-hover"
            onClick={() => this.props.goToPollWhereId(row.original.id)}
          >
            {row.value}
          </span>
        ),
        accessor: 'headline',
        minWidth: 200,
      },
      {
        Header: () => (
          <span className="flex">
            <span className="mr2">Impressions</span>
            {this.renderChevrons()}
          </span>
        ),
        accessor: 'impressions',
        sortMethod: (a, b) => a - b,
      },
      {
        Header: () => (
          <span className="flex">
            <span className="mr2">Votes</span>
            {this.renderChevrons()}
          </span>
        ),
        accessor: 'votes',
        sortMethod: (a, b) => a - b,
      },
      {
        Header: () => (
          <span className="flex">
            <span className="mr2">Engagement Rate</span>
            {this.renderChevrons()}
          </span>
        ),
        Cell: row => <span>{row.value}%</span>,
        accessor: 'engagement',
        sortMethod: (a, b) => a - b,
      },
    ]

    return (
      <section className="w-100">
        <section className="w-100 mb4 flex">
          <div className="w-30" />
          <IfAdmin>
            <CustomerSelect
              className="w-30 ml-auto bb b--op-con-dark"
              colorClass="op-con-dark"
              onChange={this.handleSelectCustomer}
              customerId={selectedCustomerId}
              placeholder="View as"
            />
          </IfAdmin>
        </section>
        <h2>AUTOMATED</h2>
        <section className="mb4 flex w-100 tc">
          <div className="bg-op-con-dark white pa4 flex flex-column justify-center w-100 relative">
            <div className="f1 fw7">
              {analytics.impressionsAutomated
                ? analytics.impressionsAutomated
                : 0}
            </div>
            <div className="mb3 f4">UNIQUE IMPRESSIONS</div>
          </div>
          <div className="bg-op-con-dark white ml-auto mr-auto pa4 flex flex-column justify-center w-100">
            <div className="f1 fw7">
              {analytics.votesAutomated ? analytics.votesAutomated : 0}
            </div>
            <div className="mb3 f4">UNIQUE VOTES</div>
          </div>
          <div className="bg-op-con-dark white pa4 flex flex-column justify-center w-100">
            <div className="f1 fw7">
              {`${
                analytics.engagementRateAutomated
                  ? analytics.engagementRateAutomated
                  : 0
              }%`}
            </div>
            <div className="mb3 f4">ENGAGEMENT RATE</div>
          </div>
        </section>
        <h2>MANUAL</h2>
        <section className="mb4 flex w-100 tc">
          <div className="bg-op-con-dark white pa4 flex flex-column justify-center w-100 relative">
            <div className="f1 fw7">
              {analytics.impressionsManual ? analytics.impressionsManual : 0}
            </div>
            <div className="mb3 f4">UNIQUE IMPRESSIONS</div>
          </div>
          <div className="bg-op-con-dark white ml-auto mr-auto pa4 flex flex-column justify-center w-100">
            <div className="f1 fw7">
              {analytics.votesManual ? analytics.votesManual : 0}
            </div>
            <div className="mb3 f4">UNIQUE VOTES</div>
          </div>
          <div className="bg-op-con-dark white pa4 flex flex-column justify-center w-100">
            <div className="f1 fw7">
              {`${
                analytics.engagementRateManual
                  ? analytics.engagementRateManual
                  : 0
              }%`}
            </div>
            <div className="mb3 f4">ENGAGEMENT RATE</div>
          </div>
        </section>
        <h2>TOTAL</h2>
        <section className="mb4 flex w-100 tc">
          <div className="bg-op-con-dark white pa4 flex flex-column justify-center w-100 relative">
            <div className="f1 fw7">
              {analytics.impressions ? analytics.impressions : 0}
            </div>
            <div className="mb3 f4">UNIQUE IMPRESSIONS</div>
          </div>
          <div className="bg-op-con-dark white ml-auto mr-auto pa4 flex flex-column justify-center w-100">
            <div className="f1 fw7">
              {analytics.votes ? analytics.votes : 0}
            </div>
            <div className="mb3 f4">UNIQUE VOTES</div>
          </div>
          <div className="bg-op-con-dark white pa4 flex flex-column justify-center w-100">
            <div className="f1 fw7">
              {`${analytics.engagementRate ? analytics.engagementRate : 0}%`}
            </div>
            <div className="mb3 f4"> ENGAGEMENT RATE</div>
          </div>
        </section>

        <div className="w-100 pl4 h3 bg-near-white flex  items-center">
          <span className="pr2"> Start date:</span>
          <OpinaryDatePicker
            className="h2 bb b--gray w-50 bg-transparent dark-gray flex-auto"
            selected={startDate}
            selectsStart
            startDate={startDate}
            endDate={endDate}
            onChange={this.handleChangeStart}
            showToolTip
          />

          <span className="pr2">End date:</span>
          <OpinaryDatePicker
            className="h2 bb b--gray w-50 bg-transparent dark-gray flex-auto"
            selected={endDate}
            selectsEnd
            startDate={startDate}
            endDate={endDate}
            onChange={this.handleChangeEnd}
          />
          <ColorButton
            className="z-3"
            colorClass="op-brand"
            borderClass="b--op-brand"
            onClick={this.handlerSearch}
          >
            Select Date
          </ColorButton>
          <ColorButton
            className="ml4"
            colorClass="gray"
            borderClass="b--gray"
            onClick={() => this.handlerDowload(analytics)}
          >
            Export to CSV
          </ColorButton>
        </div>

        <section className="bg-white">
          <ReactTable
            resizable={false}
            data={analytics.polls}
            columns={columns}
            defaultSortDesc={true}
            defaultSorted={[{ id: 'impressions', desc: true }]}
            defaultPageSize={10}
            getTheadTrProps={() => ({ className: 'flex' })}
            getTheadThProps={() => ({
              className: 'bg-op-con-dark bn white ws-normal tl pv2 f6',
            })}
            getTrProps={() => ({ className: 'flex' })}
            getTdProps={() => ({
              className: 'gray b--moon-gray bt pv2 flex items-center f6',
              style: { minHeight: '3rem' },
            })}
          />
        </section>
      </section>
    )
  }
}

const mapStateToProps = state => {
  return {
    selectedCustomerId: getSelectedCustomerId(state),
    analytics: getAnalytics(state),
    user: selectCurrentUser(state),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    selectCustomer: customer => dispatch(selectCustomer(customer)),
    clearAnalyticsPolls: () => dispatch(clearAnalyticsPolls()),
    fetchAnalyticsImpressions: (customerId, timeframe) =>
      dispatch(fetchAnalyticsImpressions(customerId, timeframe)),
    goToPollWhereId: pollId => dispatch(goToPollWhereId(pollId)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Analytics)



// WEBPACK FOOTER //
// ./src/components/Analytics/index.js